import styled from "styled-components"
import { CursorCrosshairBlack, CursorCrosshairWhite } from "shared/Styles/Cursors"

export const MenuButton = styled.button`
  font-size: 10px;
  font-family: "Bebas Kai Regular", Arial, Helvetica, sans-serif;
  position: fixed;
  z-index: 6;
  text-align: center;
  letter-spacing: 5px;
  right: 45px;
  top: 80px;
  transition: all 0.5s ease-in-out;
  border: none;
  width: 95px;
  height: 95px;
  border-radius: 100%;
  padding: 1px 4px 0 8px;
  ${props=>(props.light && !props.active ? CursorCrosshairBlack : CursorCrosshairWhite)}
  background: ${({ active, theme }) =>
    active ? theme.color.primary : "transparent"};
  color: ${({ light, active }) => (light && !active ? "black" : "white")};

  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.tabletSmall}) {
    right: 30px;
    top: 20px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phoneBig}) {
    width: 64px;
    height: 64px;
    letter-spacing: 2px;
    &:after{
        height: 60px !important;
    }
  }

  &:after {
    content: "";
    height: 64px;
    width: 1px;
    position: absolute;
    top: -44px;
    left: 50%;
    transform: translateX(-50%);
    transition: background-color 0.5s ease-in-out;
    background-color: ${({ light, active }) =>
      light && !active ? "black" : "white"};
  }
  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    border: 1px solid
      ${({ light, active }) =>
        active ? "transparent" : light ? "black" : "white"};
    transition: all 0.5s ease-in-out;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &:hover:before {
    transform: translate(-50%, -50%) scale(1.2);
  }
`
